import bezier from "bezier-easing";

export const easeInOutCubic = bezier(0.65, 0, 0.35, 1);
